<template>
  <div
    class="TNovoTipoAtividade"
    data-testid="TNovoTipoAtividade"
  >
    <div class="TNovoTipoAtividade__Header">
      <slot name="navegacao" />
    </div>
    <div class="TNovoTipoAtividade__Centro">
      <slot name="centro" />
    </div>
    <div class="TNovoTipoAtividade__Botoes">
      <slot name="acoes" />
    </div>
    <slot name="modais" />
  </div>
</template>
<script lang="ts" setup></script>
<style lang="scss" scoped>
  @import "./TNovoTipoAtividade.style.scss";
</style>
